import React from 'react';
import { HeaderConsumer } from '../contexts/HeaderContext';

export function withHeaderMessages(Component) {
    class HeaderMessageResetComponent extends React.Component {
        componentWillUnmount() {
            this.props.headerContext.clearHeader();
        }
        render() {
            const {headerContext: _,  ...componentProps} = this.props;
            return <Component {...componentProps} header={ { setHeader: this.props.headerContext.setHeader } } />
        }
    } 
    return class extends React.Component {
        render() {
            return (
                <HeaderConsumer>
                    {context => (
                        <HeaderMessageResetComponent {...this.props} headerContext={ context } />
                    )}
                </HeaderConsumer>
            );
        }
    }
}